import React from 'react';
import type { CellRenderProps } from '@axiom/ui';
import { Link } from 'react-router';

import type { CandidateDetail } from '../../api/chat-api';
import { MatchGridUtil } from '../../utils/match-grid-util';

/**
 * A candidate's name in the grid, linked to their profile.
 *
 * **Takes the cell's props rather than a candidate**, so it can be handed to `cellRender` as it is:
 * an arrow there would be a new component identity every render, which `react/no-unstable-nested-
 * components` rejects.
 */
export const MatchGridCandidateName = ({
  data,
}: CellRenderProps<CandidateDetail>) => {
  const displayName = data.calculatedDisplayName ?? MatchGridUtil.NOT_YET;

  // No id, no route to build - so the name stands as plain text.
  if (!data.id) return displayName;

  return (
    <Link
      data-test={`CANDIDATE_NAME_LINK_${data.id}`}
      to={`/talent-detail/${data.id}`}
      rel="noopener noreferrer"
      target="_blank"
    >
      {displayName}
    </Link>
  );
};
